<template>
    <div class="max-width">
        <h1 class="title">
            Schema specifications
        </h1>
        <div class="columns">
            <div class="column">
                <b-table
                    :data="schemata"
                    default-sort="Name"
                    :striped="true"
                    :narrowed="true"
                    :hoverable="true"
                    class="table-height site-sticky-header">
                    <b-table-column
                        v-slot="props"
                        field="Name"
                        label="Name"
                        sortable>
                        <span class="name_column">
                            <router-link :to="getSchemaLink(props.row.Identity)">
                                {{ props.row.Name }}
                            </router-link>
                        </span>
                    </b-table-column>
                    <b-table-column
                        v-slot="props"
                        field="Description"
                        label="Description">
                        {{ props.row.Description }}
                    </b-table-column>
                </b-table>
            </div>
            <div class="column is-3">
                <tag-introduction :tag="'Schema (Ontology)'" />
            </div>
        </div>
    </div>
</template>

<script setup>
    import TagIntroduction from '@/shared/components/TagIntroduction.vue';
    import { sqlQuery } from '@/shared/helpers/api.ts';
    import { getSchemaLink } from '@/apps/schema/schemaHelper.js';
    import { onMounted, ref } from 'vue';
    import { http } from '@/shared/httpWrapper';

    const schemata = ref([]);

    onMounted(async () => {
        schemata.value = (await sqlQuery(http, {
            query: `SELECT [Name], [Description], [Identity]
                    FROM [Schema]
                    WHERE [IsValid] = 1`
        })).data;
    });
</script>
<style scoped>
.name_column{
    white-space: nowrap;
    overflow: visible;
    text-overflow: ellipsis;
}
.max-width{
    width: 100%;
}
</style>
